// Canonical meeting sub-types for the "Meeting" idle reason.
// Defined ONCE here and mirrored in backend/idle_constants.py (MEETING_TYPES).
// The Phase 2 idle-disposition system imports these exact `value`s to pre-approve
// meeting idle — do not rename values without updating both files and any dispositions.
// huddle/training were added with the P5 presence selector, which reuses this SAME meeting
// vocabulary. Keep in lockstep with backend/idle_constants.py MEETING_TYPE_LABELS.
export const MEETING_TYPES = [
  { value: 'team', label: 'Team meeting' },
  { value: 'joey', label: 'Meeting with Joey' },
  { value: 'shar', label: 'Meeting with Shar' },
  { value: 'huddle', label: 'Huddle' },
  { value: 'training', label: 'Training' },
];

export const MEETING_TYPE_LABELS = MEETING_TYPES.reduce((m, t) => { m[t.value] = t.label; return m; }, {});
